import { AxiosError } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { NewBaseClient } from '../clients/new-base.client';
import { IResponseMessages } from '../models/response-messages.model';

export function useSave<Data extends Record<string, any>>(
    client: NewBaseClient<Data>,
    listKey: string,
    itemKey: string,
): UseMutationResult<string, AxiosError, { data: Data; messages?: IResponseMessages }> {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ data, messages }): Promise<string> =>
            data?.id ? client.updateOne(data?.id, data, messages) : client.createOne(data, messages),
        onSuccess: async (id) => {
            await queryClient.invalidateQueries({ queryKey: [listKey] });
            await queryClient.invalidateQueries({ queryKey: [itemKey, id] });
        },
    });
}

export function useDelete<Data extends Record<string, any>>(
    client: NewBaseClient<Data>,
    listKey: string,
): UseMutationResult<void, AxiosError, { id: string; messages?: IResponseMessages }> {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, messages }) => client.deleteOne(id, messages),
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: [listKey] });
        },
    });
}
